// Brand logos. MADIO's own files ship with the app (public/brand/madio/); another company shows its
// logo_url (Business Settings) or a letter mark, never MADIO's. A division's own logo_url (Business
// Settings → Divisions) wins over the bundled file.
export const MADIO_TENANT = "madio";

const MADIO = {
  logo: "/brand/madio/madio.png",
  logoLight: "/brand/madio/madio-light.png",                 // on dark or photo backgrounds
  divisions: {
    Furniture: "/brand/madio/furniture.png",
    MAP: "/brand/madio/map.png",
    "D&W": "/brand/madio/dw.png",
  },
};

const isMadio = (tenant) => (tenant?.id || "") === MADIO_TENANT;

/** The company logo for the app header and printouts, or "" (show the letter mark). */
export const companyLogo = (tenant) => tenant?.logo_url || (isMadio(tenant) ? MADIO.logo : "");

/** A division's logo: its own logo_url, else MADIO's bundled file for a MADIO division, else "". */
export function divisionLogo(tenant, division, divisions = []) {
  const slug = typeof division === "string" ? division : division?.slug;
  const own = (divisions || []).find((d) => d.slug === slug || d.name === slug)?.logo_url;
  if (own) return own;
  return isMadio(tenant) ? MADIO.divisions[slug] || "" : "";
}

/** Before sign-in the tenant is unknown: MADIO's deployments show its logo, any other (e.g. Lucente's
 * own domain, or a deploy that sets REACT_APP_PRODUCT_NAME) keeps the neutral letter mark. */
export function loginLogo(light = false) {
  if (process.env.REACT_APP_PRODUCT_NAME || process.env.REACT_APP_LOGO_LETTER) return "";
  const host = (typeof window !== "undefined" && window.location.hostname) || "";
  if (/lucent/i.test(host)) return "";
  return light ? MADIO.logoLight : MADIO.logo;
}
